
import Vue from 'vue'
import axios from 'axios'
import { PatientFormBasicInfo, Tag, FormUserType }  from '../../../types/Sapphire_dto'

const AddFormPopup = Vue.extend({
    name: "add-form-component",
    components: {
    },
    props: {
        // tagId: Number
    },
    data: function () {
        return {
            patientId: 0,
            formsList: [] as PatientFormBasicInfo[],
            filteredFormsLibrary: [] as PatientFormBasicInfo[],
            formUserTypes: [] as FormUserType[],
            selectedFormUserTypes: [] as FormUserType[],
            formTags: [] as Array<Tag>,
            selectedFormTags: [] as Array<Tag>,
            searchTextBox: '',
            tagIds: '',
            openPopup: false,
            showFavoriteFormsButton: true,
            showAllFormsButton: false
        };
    },
    mounted: function () {
      //mounted is an event in the lifecyle of a vue component
    },
    computed: {
    },    
    watch: {
    },
    methods: {
        limitTags (count) {
            return `and ${count} more`
        },
        limitTypes (count) {
            return `and ${count} more`
        },
        async show(patID, tagIDs, typeIDs) {
          var vm = this;
          vm.formsList = [];
          vm.selectedFormUserTypes = [];
          vm.selectedFormTags = [];
          vm.searchTextBox = '';
          vm.patientId= patID;
          await vm.getFormTags(tagIDs);
          await vm.getFormUserTypes(typeIDs);
          
          vm.getFilteredFormsLibrary();

          vm.openPopup = true;
        },
        closeAddFormPopup: function () {
            var vm = this;
            vm.openPopup = false;
        },
        openFormInNewWindow: function (form: PatientFormBasicInfo, t: number) {
            var serviceURL;
            switch (t) {
                case 1: //open form
                    serviceURL = "PopulateTitleLink";
                    break;
                case 2: //print form
                    serviceURL = "PopulatePrintLink";
                    break;
                case 3: //print form (no patient)
                    serviceURL = "PopulatePrintLinkNoPatient";
                    break;
                default:
                    return false;
            }

            //console.log(t);
            // var json = JSON.stringify(form);
            var json = form;

             axios.post("../../Common/Services/EmarClientOperations.svc/" + serviceURL, {
                form: JSON.stringify(json)              
             })
            .then(response => {
                    // if (typeof e.target.responseObj.d == 'undefined' || e.target.responseObj.d.length == 0) {
                    //     return;
                    // }
                    var url = response.data.d;
                    //console.log('url=' + url);

                    if (t == 1) {
                      window.open(url, '_blank', 'toolbar=no,scrollbars=no,resizable=yes,menubar=no,status=no,titlebar=no,top=100,left=1,width=1240,height=750,innerHeight=750,innerWidth=1240');
                    }
                    else {
                      window.open(url);
                    }
            });
            return false;
        },
        getAllFormsLibrary: function () {
            var vm = this;
            // vm.showOverlay=true;
            axios.post("../../Common/Services/EmarClientOperations.svc/GetFormsForAddPopup", {
                 patientId: vm.patientId
            })
            .then(response => {
                vm.formsList = [];
                vm.filteredFormsLibrary = [];

                var tempList = [] as Array<PatientFormBasicInfo>;

                tempList = JSON.parse(response.data.d);
                tempList.forEach(function(v) {
                  vm.formsList.push(v);
                  vm.filteredFormsLibrary.push(v);
                });
                // vm.showOverlay=false;
            }).catch(function () {
                // vm.showOverlay=false;
            });
        },
        getFavoriteFormsLibrary: function () {
            var vm = this;
            // vm.showOverlay=true;
            axios.post("../../Common/Services/EmarClientOperations.svc/GetFavFormsForAddPopup", {
                patientId: vm.patientId
            })
            .then(response => {
                vm.formsList = [];
                vm.filteredFormsLibrary = [];

                var tempList = [] as Array<PatientFormBasicInfo>;

                tempList = JSON.parse(response.data.d);
                tempList.forEach(function(v) {
                  vm.formsList.push(v);
                  vm.filteredFormsLibrary.push(v);
                });
                // vm.showOverlay=false;
            }).catch(function () {
                // vm.showOverlay=false;
            });
        },
        getFilteredFormsLibrary: function () {
            var vm = this;
            // vm.showOverlay=true;
            axios.post("../../Common/Services/EmarClientOperations.svc/GetFilteredFormsForAddPopup", {
                patientId: vm.patientId,
                userTypes: JSON.stringify(vm.selectedFormUserTypes),
                tags: JSON.stringify(vm.selectedFormTags)
            })
            .then(response => {
                vm.formsList = [];
                vm.filteredFormsLibrary = [];

                var tempList = [] as Array<PatientFormBasicInfo>;

                tempList = JSON.parse(response.data.d);
                tempList.forEach(function(v) {
                  vm.formsList.push(v);
                  vm.filteredFormsLibrary.push(v);
                });
                // vm.showOverlay=false;
            }).catch(function () {
                // vm.showOverlay=false;
            });
        },
        async getFormUserTypes(typeIDs) {
            var vm = this;
            var response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetPatientFormUserTypesByFacilityTS");
            vm.formUserTypes = [];
            vm.formUserTypes = JSON.parse(response.data.d);
            if (typeIDs) {
                vm.handlePreselectedUserTypes(typeIDs);
            }
        },
        async getFormTags(tagIDs) {
            var vm = this;
            var response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetAllTagsTS")
            vm.formTags = [];
            vm.formTags = JSON.parse(response.data.d);      
                                    
            if (tagIDs) {
                vm.handlePreselectedTags(tagIDs);
            }
        },
        searchFilteredFormsLibrary: function () {
          var vm = this;

          var tempList = [];
          vm.filteredFormsLibrary = [];
          // console.log(vm.searchTextBox);

          tempList = vm.formsList.filter(c => c.Name.toLowerCase().includes(vm.searchTextBox.toLowerCase()));

          tempList.forEach(function(v) {
            vm.filteredFormsLibrary.push(v);
          });
        },
        handleBtnGetFilteredFormsLibraryClick: function () {
            var vm = this;
            vm.searchTextBox = '';
            vm.getFilteredFormsLibrary();
            this.showFavoriteFormsButton = true;
            this.showAllFormsButton = false;
        },
        handleBtnGetAllFormsLibraryClick: function () {
            var vm = this;
            vm.searchTextBox = '';
            vm.selectedFormUserTypes = [];
            vm.selectedFormTags = [];
            vm.getAllFormsLibrary();
            this.showAllFormsButton = false;
            this.showFavoriteFormsButton = true;
        },
        handleBtnGetFavoriteFormsLibrary: function () {
            var vm = this;
            vm.searchTextBox = '';
            vm.selectedFormUserTypes = [];
            vm.selectedFormTags = [];
            vm.getFavoriteFormsLibrary();
            this.showFavoriteFormsButton = false;
            this.showAllFormsButton = true;
        },
        handlePreselectedTags: function (prefilterTagIds) {
          var vm = this;
          vm.selectedFormTags = [];

          var tagIds = prefilterTagIds.split(',');
          tagIds.forEach(function(v) {
              const result = vm.formTags.find(tag => tag.ID === Number(v));
              vm.selectedFormTags.push(result);
          });
          
          return true;
      },
      handlePreselectedUserTypes: function (prefilterUserTypes) {
          var vm = this;
          vm.selectedFormUserTypes = [];

          var typeIds = prefilterUserTypes.split(',');
          typeIds.forEach(function(v) {
              const result = vm.formUserTypes.find(ut => ut.ID === Number(v));
              vm.selectedFormUserTypes.push(result);
          });
          return true;
      }
    }
  });

export type AddFormPopupRef = InstanceType<typeof AddFormPopup>;
export default AddFormPopup;


